import React from "react";
import SectionImg from "../../common/images/pos_sec_img.png";
import stepOne from "../../common/images/pstep1.png";
import stepTwo from "../../common/images/pstep2.png";
import stepThree from "../../common/images/pstep3.png";
import stepFour from "../../common/images/pstep4.png";
import stepFive from "../../common/images/pstep5.png";

const Section_one = () => {
  const features = [
    {
      img: stepOne,
      title: "Fast and Secure Transactions",
      desc: "Process sales quickly and securely with support for multiple payment methods, including cash, credit/debit cards, and mobile wallets.",
    },
    {
      img: stepTwo,
      title: "Real-Time Inventory Management",
      desc: "Track stock levels in real-time, automate reordering, and get low-stock alerts to avoid disruptions.",
    },
    {
      img: stepThree,
      title: "Sales and Performance Reporting",
      desc: "Generate detailed reports to track sales trends, employee performance, and customer behavior — helping you make data-driven decisions.",
    },
    {
      img: stepFour,
      title: "Customer Relationship Management (CRM)",
      desc: "Build customer profiles, track purchase history, and offer targeted discounts and loyalty programs.",
    },
    {
      img: stepFive,
      title: "Employee Management",
      desc: "Set user roles, monitor employee performance, and manage shift schedules from a single platform.",
    },
  ];

  return (
    <div>
      <div
        className="relative bg-secondary  bg-cover bg-center bg-no-repeat text-white md:py-7 py-5 "
        style={{ backgroundImage: "url('/android-dot.png')" }}
      >
        {/* Main Heading */}
        <div className="max-w-[1280px] mx-auto text-center px-5 md:px-10 md:pt-7 md:pb-5 pt-0 pb-0">
          <h2 className="small:text-3xl text-2xl small:overflow-hidden small:whitespace-nowrap  small:animate-typing font-bold md:text-4xl ">
          Key Features   </h2>{" "}
          <div className="underline w-1/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-primary">
            <p className="h-[5px] rounded-xl bg-primary w-[50%]"></p>
          </div>
        </div>

        {/* Image Below Paragraph */}
        <div className="mt-6 max-w-[1280px] mx-auto  small:flex hidden justify-center">
          <img
            src={SectionImg}
            alt="Illustration"
            className="w-full px-5  object-contain"
          />
        </div>
        <div className="px-5 small:hidden grid xs:grid-cols-2 grid-cols-1 gap-3 text-center">
        {features.map((feature, idx) => (
          <div key={idx} className="flex flex-col items-center text-white">
            <img src={feature.img} alt={feature.title} className="w-14 h-14 mb-4" />
            <h3 className="text-md font-bold text-yellow-400 mb-2">{feature.title}</h3>
            <p className="text-sm">{feature.desc}</p>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default Section_one;
